import { supabase } from '@/lib/supabase';

export interface CloudflareUploadResult {
  name: string;
  path: string;
  url: string;
  downloadUrl: string;
  contentType: string;
}

export async function uploadToCloudflareR2(
  file: File,
  kind: 'produto-imagem' | 'ata-anexo',
  ownerName: string,
): Promise<CloudflareUploadResult> {
  if (!supabase) {
    throw new Error('Supabase nao configurado. Preencha VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY.');
  }

  const body = new FormData();
  body.append('file', file);
  body.append('kind', kind);
  body.append('ownerName', ownerName);

  const { data, error } = await supabase.functions.invoke<CloudflareUploadResult>('r2-upload', {
    body,
  });

  if (error) {
    throw new Error(
      `${error.message}. Verifique se a Edge Function r2-upload foi publicada e se os secrets do Cloudflare R2 foram configurados.`,
    );
  }

  if (!data) {
    throw new Error('Upload sem retorno do Cloudflare R2.');
  }

  return data;
}
